import { ThreadContext, ThreadContextSettings } from '@/contexts/thread/helpers';
import { useContext } from 'react';

const useThread = () => useContext<ThreadContextSettings>(ThreadContext);

export default useThread;
